// export const ExpenseRouting = [
//   {
//     path: "/platform-electronic-visa/expense/:type",
//     name: "expenseAll",
//     component: () => import("@/views/platform-electronic-visa/expense/index.vue"),
//     meta: { title: "费用中心", icon: "dashboard" },
//   },

import { RouterView } from "vue-router";
import { AccountRouting } from "./account/account.routing";
import { InvoiceRouting } from "./invoice/invoice.routing";
import { OrderRouting } from "./order/order.routing";
import { GoOrderRouting } from "./goorder/goorder.routing";

export const ExpenseRouting = {
  path: "/expense",
  name: "expense",
  redirect: "/expense/account",
  component: RouterView,
  meta: { title: "费用中心", icon: "xiangmu" },
  children: [...AccountRouting, ...InvoiceRouting, ...OrderRouting, ...GoOrderRouting],
};
